export default "__VITE_ASSET__BcgMUM4r__"